module.exports = __webpack_public_path__ + "img/charging-labels.ad8ac1ab.png";